import { render, staticRenderFns } from "./TeacherList.vue?vue&type=template&id=3810d1ea&"
import script from "./TeacherList.vue?vue&type=script&lang=js&"
export * from "./TeacherList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports